import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-money",
  "use": "icon-money-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-money\"><path d=\"M832 64a96 96 0 0 1 96 96V768l-192 192H192a96 96 0 0 1-96-96v-704A96 96 0 0 1 192 64z m0 96H192v704h504.256L832 728.256V160zM625.152 252.16L692.992 320 596.864 416H704V512H560v64H704v96H560V768h-96v-96H320V576h144V512H320V416h106.88L331.008 320l67.84-67.84L512 365.12 625.152 252.16z\" p-id=\"899\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/money.svg
// module id = ig9B
// module chunks = 69